import React from 'react';

const NewYearBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 50% 25%, rgba(245, 158, 11, 0.18) 0%, rgba(99, 102, 241, 0.15) 40%, transparent 70%), radial-gradient(circle at 85% 85%, rgba(236, 72, 153, 0.12) 0%, transparent 60%)'
        }}
      />

      <svg
        viewBox="0 0 1600 1000"
        className="w-full h-full object-cover"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="skylineGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1E1B4B" />
            <stop offset="100%" stopColor="#090A1A" />
          </linearGradient>
          <filter id="fireworkGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" />
          </filter>
        </defs>

        {/* Grand Fireworks Bursts across Midnight Sky */}
        {/* Burst 1: Left Champagne Gold */}
        <g transform="translate(320, 220)">
          <circle cx="0" cy="0" r="45" fill="#F59E0B" fillOpacity="0.2" filter="url(#fireworkGlow)" />
          {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((deg, i) => (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(deg * Math.PI / 180) * 85}
              y2={Math.sin(deg * Math.PI / 180) * 85}
              stroke="#FDE68A"
              strokeWidth="2"
              strokeDasharray="4 6"
              strokeLinecap="round"
            />
          ))}
          <circle cx="0" cy="0" r="6" fill="#FFFFFF" />
        </g>

        {/* Burst 2: Center Giant Celebration Fireworks */}
        <g transform="translate(800, 160)">
          <circle cx="0" cy="0" r="60" fill="#EC4899" fillOpacity="0.2" filter="url(#fireworkGlow)" />
          {[0, 22.5, 45, 67.5, 90, 112.5, 135, 157.5, 180, 202.5, 225, 247.5, 270, 292.5, 315, 337.5].map((deg, i) => (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(deg * Math.PI / 180) * 110}
              y2={Math.sin(deg * Math.PI / 180) * 110}
              stroke={i % 2 === 0 ? "#F59E0B" : "#EC4899"}
              strokeWidth="2"
              strokeDasharray="5 7"
              strokeLinecap="round"
            />
          ))}
          <circle cx="0" cy="0" r="8" fill="#FFFFFF" />
        </g>

        {/* Burst 3: Right Electric Cyan / Indigo */}
        <g transform="translate(1280, 240)">
          <circle cx="0" cy="0" r="45" fill="#38BDF8" fillOpacity="0.2" filter="url(#fireworkGlow)" />
          {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((deg, i) => (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(deg * Math.PI / 180) * 80}
              y2={Math.sin(deg * Math.PI / 180) * 80}
              stroke="#A5F3FC"
              strokeWidth="2"
              strokeDasharray="3 5"
              strokeLinecap="round"
            />
          ))}
          <circle cx="0" cy="0" r="5" fill="#FFFFFF" />
        </g>

        {/* Metropolis Skyline Silhouettes with Window Grids */}
        <g fill="url(#skylineGrad)">
          <rect x="0" y="600" width="120" height="400" />
          <polygon points="60,540 50,600 70,600" />

          <rect x="140" y="520" width="140" height="480" />
          <line x1="210" y1="460" x2="210" y2="520" stroke="#F59E0B" strokeWidth="2" />

          <rect x="300" y="640" width="100" height="360" />
          <rect x="420" y="560" width="160" height="440" />

          <rect x="1050" y="580" width="130" height="420" />
          <rect x="1200" y="510" width="150" height="490" />
          <line x1="1275" y1="440" x2="1275" y2="510" stroke="#6366F1" strokeWidth="2" />

          <rect x="1370" y="620" width="110" height="380" />
          <rect x="1500" y="540" width="120" height="460" />
        </g>

        {/* Illuminated City Windows */}
        <g fill="#FEF08A" opacity="0.6">
          <rect x="160" y="540" width="8" height="12" />
          <rect x="180" y="540" width="8" height="12" />
          <rect x="220" y="540" width="8" height="12" />
          <rect x="160" y="580" width="8" height="12" />
          <rect x="200" y="580" width="8" height="12" />
          <rect x="240" y="580" width="8" height="12" />
          <rect x="1220" y="530" width="8" height="12" />
          <rect x="1260" y="530" width="8" height="12" />
          <rect x="1300" y="530" width="8" height="12" />
          <rect x="1240" y="570" width="8" height="12" />
          <rect x="1280" y="570" width="8" height="12" />
        </g>

        {/* Foreground Waterfront Reflection Line */}
        <rect x="0" y="740" width="1600" height="260" fill="#060714" />
        <line x1="0" y1="740" x2="1600" y2="740" stroke="#F59E0B" strokeWidth="1.5" strokeOpacity="0.4" />
      </svg>
    </div>
  );
};

export default NewYearBackgroundGraphics;
